export default [
  {
    path: '/app/users',
    name: 'Users',
    component: () => import('@/views/Users/Index.vue'),
    meta: {
      pageTitle: 'nav.users',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
      resource: 'ADMIN_USER_LIST',
      action: 'read',
      packageLimit: {
        subject: 'SUBUSERS_MANAGEMENT',
        limit: 1,
      },
    },
  },
  // {
  //   path: '/app/users/add',
  //   name: 'UserAdd',
  //   component: () => import('@/views/Users/Add.vue'),
  //   meta: {
  //     pageTitle: 'nav.users',
  //     breadcrumb: [
  //       {
  //         text: 'breadcrumb.list',
  //         to: '/app/users',
  //         active: false,
  //       },
  //       {
  //         text: 'breadcrumb.create',
  //         active: true,
  //       },
  //     ],
  //     resource: 'ADMIN_USER_ADD',
  //     action: 'read',
  //   },
  // },
  {
    path: '/app/users/edit/:id',
    name: 'UserEdit',
    component: () => import('@/views/Users/Edit.vue'),
    meta: {
      pageTitle: 'nav.users',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/app/users',
          active: false,
        },
        {
          text: 'breadcrumb.update',
          active: true,
        },
      ],
      resource: 'ADMIN_USER_EDIT',
      action: 'read',
      packageLimit: {
        subject: 'SUBUSERS_MANAGEMENT',
        limit: 1,
      },
    },
  },
]
